module.exports = __webpack_public_path__ + "img/ic_points_op_black.93c46b6d.svg";